import { render, staticRenderFns } from "./ConferencesList.vue?vue&type=template&id=2b4c698a&scoped=true&"
import script from "./ConferencesList.vue?vue&type=script&lang=js&"
export * from "./ConferencesList.vue?vue&type=script&lang=js&"
import style0 from "./ConferencesList.vue?vue&type=style&index=0&id=2b4c698a&scoped=true&lang=scss&"
import style1 from "./ConferencesList.vue?vue&type=style&index=1&id=2b4c698a&lang=scss&scoped=true&"
import style2 from "./ConferencesList.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4c698a",
  null
  
)

export default component.exports